import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Home from '../pages/Home';
import Admin from '../pages/Admin';
import Armazens from '../pages/Armazens';
import Lavouras from '../pages/Lavouras';
import Safras from '../pages/Safras';
import Cargas from '../pages/Cargas';
import Vendas from '../pages/Vendas';
import Insumos from '../pages/Insumos';
import Custos from '../pages/Custos';
import Resultado from '../pages/Resultado';
import Usuarios from '../pages/Usuarios';
import MinhaAssinatura from '../pages/MinhaAssinatura';
import LivroCaixa from '../pages/LivroCaixa';
import ContasAPagar from '../pages/ContasAPagar';
import ContasAReceber from '../pages/ContasAReceber';
import Maquinario from '../pages/Maquinario';
import RelatoriosHome from '../pages/relatorios/RelatoriosHome';
import RelatorioProducaoPage from '../pages/relatorios/RelatorioProducaoPage';
import CompararAreas from '../pages/relatorios/CompararAreas';
import CompararSafras from '../pages/relatorios/CompararSafras';
import CustosPorLavoura from '../pages/relatorios/CustosPorLavoura';
import Notificacoes from '../pages/Notificacoes';
import GerenciarFazendas from '../pages/GerenciarFazendas';
import NotFound from '../pages/NotFound';

export default function AppRoutes() {
  return (
    <Routes>
      <Route path="/"         element={<Home />} />
      <Route path="/cargas"   element={<Cargas />} />
      <Route path="/vendas"   element={<Vendas />} />
      <Route path="/safras"   element={<Safras />} />
      <Route path="/lavouras" element={<Lavouras />} />
      <Route path="/armazens" element={<Armazens />} />
      <Route path="/resultado" element={<Resultado />} />
      <Route path="/relatorios" element={<RelatoriosHome />} />
      <Route path="/relatorios/producao" element={<RelatorioProducaoPage />} />
      <Route path="/relatorios/comparar-areas" element={<CompararAreas />} />
      <Route path="/relatorios/comparar-safras" element={<CompararSafras />} />
      <Route path="/relatorios/custos-lavoura" element={<CustosPorLavoura />} />
      <Route path="/insumos"  element={<Insumos />} />
      <Route path="/custos"   element={<Custos />} />
      <Route path="/usuarios" element={<Usuarios />} />
      <Route path="/minha-assinatura" element={<MinhaAssinatura />} />
      <Route path="/livro-caixa" element={<LivroCaixa />} />
      <Route path="/contas-a-pagar" element={<ContasAPagar />} />
      <Route path="/contas-a-receber" element={<ContasAReceber />} />
      <Route path="/maquinario" element={<Maquinario />} />
      <Route path="/notificacoes" element={<Notificacoes />} />
      <Route path="/entrar-em-fazenda" element={<GerenciarFazendas modo="entrar" />} />
      <Route path="/criar-fazenda" element={<GerenciarFazendas modo="criar" />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="*"         element={<NotFound />} />
    </Routes>
  );
}
